<template>
    <form-select
            :country="country"
            :disabled="disabled"
            :error="error"
            :inputHolderClasses="inputHolderClasses"
            :label="label"
            :labelClasses="labelClasses"
            :loading="loading"
            :multiple="multiple"
            :name="name"
            :no-form-group="noFormGroup"
            :no-row="noRow"
            :no-wrapper="noWrapper"
            :object-name-key="objectNameKey"
            :options="result"
            :required="required"
            :track-by="trackBy"
            :value="value"
            v-model="model"
            :placeholder="placeholder"
            v-bind="$attrs"
    />

</template>
<script>
    import RetrieveMixin from '~/mixins/retrieve';

    export default {
        name: 'backend-select',
        mixins: [RetrieveMixin],
        props: {
            country: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
            error: {
                type: String,
                default: null,
            },
            inputHolderClasses: {
                type: String,
                required: false,
            },
            label: {
                type: String,
                required: false,
            },
            labelClasses: {
                type: String,
                required: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            name: {
                type: String,
                required: true,
            },
            noFormGroup: {
                type: Boolean,
                required: false,
                default: false,
            },
            noRow: {
                type: Boolean,
                required: false,
                default: false,
            },
            noWrapper: {
                type: Boolean,
                required: false,
                default: false,
            },
            objectNameKey: {
                type: String,
                required: false,
                default: 'name',
            },
            onInput: {
                type: Function,
                default: () => {},
            },
            prefixDataWith: {
                type: Array,
                required: false,
                default: () => [],
            },
            suffixDataWith: {
                type: Array,
                required: false,
                default: () => [],
            },
            required: {
                type: Boolean,
                required: false,
                default: false,
            },
            resultMap: {
                type: Function,
                required: false,
                default: array => array,
            },
            return: {
                type: String,
                required: false,
            },
            trackBy: {
                type: String,
                required: false,
                default: 'name',
            },
            value: {
                default: null,
            },
            valueKey: {
                default: 'id',
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
        },
        data() {
            return {
                model: null,
                result: [],
                initialSet: false,
                loading: true,
            };
        },
        watch: {
            model(newVal, oldVal) {
                // Check if we want a specific key
                if (typeof this.return !== 'undefined' && typeof newVal !== 'undefined' && newVal !== null) {
                    // Check if out value is an array
                    if (Array.isArray(newVal)) {
                        // If it is an array grab the return keys only
                        let returnItem = newVal.map((item) => {
                            return item[this.return];
                        });

                        this.emitInput(returnItem);
                        return;
                    }
                    // Emit the key of the object given in return
                    this.emitInput(newVal[this.return]);
                    return;
                }

                // Return the object
                this.emitInput(newVal);
            },
            value(val) {
                if (val === null) {
                    this.model = null;
                } else if(! (val instanceof Array)) {
                    let result = this.result.find(r => {
                        if (typeof this.return !== 'undefined') {
                            return r[this.return] === val;
                            // If both are an object and have an id property we will compare that instead
                        } else if (r instanceof Object && r.hasOwnProperty('id') && val instanceof Object && val.hasOwnProperty('id')) {
                            return r.id === val.id;
                        }

                        return r === val;
                    });

                    // If objects, check if id is same, then don't do stuff
                    if (this.model instanceof Object && this.model.hasOwnProperty('id') && val instanceof Object && val.hasOwnProperty('id')) {
                        if (this.model.id === val.id) {
                            return;
                        }
                    }

                    this.model = result;
                } else if((val instanceof Array)) {
                    if (val.length > 0 && this.result.length > 0) {
                        let result = val.map((item) => {
                            return this.result.find(element => element.id === item);
                        })

                        // Stop looping
                        if (_.isEqual($parseStringify(this.model), $parseStringify(result))) {
                            return
                        }

                        this.model = result;
                    }
                }
            },
        },
        mounted: function () {
            if (!this.route && this.options && this.options.length) {
                this.loading = false;
            }
            this.$on('afterRetrieve', function (result) {
                this.afterRetrieve(result);
            });
        },
        methods: {
            filter(item) {
                // Check wether the key for the comparison is available
                if (this.valueKey in item) {
                    // Check wether its an array
                    if (Array.isArray(this.value)) {
                        // If it is an array map over it to only return the value key and check if it is included
                        return this.value.map((item) => {
                            return item[this.valueKey];
                        }).includes(item[this.valueKey]);
                    }
                    if (_.isObject(this.value)) {
                        return item[this.valueKey] == this.value[this.valueKey];
                    }
                    return item[this.valueKey] == this.value;
                }
            },

            afterRetrieve(result) {
                if (!Array.isArray(result)) {
                    console.warn('Select expected array got ' + typeof result);
                    this.result = [];
                }

                this.loading = false;

                this.result = this.resultMap(result);

                this.result.unshift(...this.prefixDataWith);
                this.result.push(...this.suffixDataWith);

                if (this.value !== null) {
                    this.model = this.multiple ? this.result.filter(this.filter) : this.result.filter(this.filter)[0];
                }
                this.$emit('optionsRetrieved')
            },

            emitInput(value) {
                this.$emit('keydown', value); // Fix for form error disappearing
                this.$emit('input', value);
                this.onInput(value);
            },
        },
    };
</script>
